(ns pfo.flag)

(def feature-set (into #{} js/FEATURES))

(defn enabled [flag] (contains? feature-set flag))

(defn document-queue-enabled?
  "Mobile and novice uploads both land in the ingestion queue, so either switch
  must make it reachable on the desktop."
  []
  (or (enabled "mobile-app") (enabled "novice")))
